import React from "react";
import Query from "../../components/Query";
import HOME_QUERY from "../../queries/home";
import Push from "../../components/Push";
import TeamBlock from "../../components/Home/team";
import LeistungenBlock from "../../components/Home/leistungen";
import FAQBlock from "../../components/Home/faq";
import ReferalBlock from "../../components/Home/referal";
import IntensivekursBlockNEW from "../../components/Home/intensivekurs_new";
import HomeHeader from "../../components/Header";
import AboutSliderSection from "../../components/Content/aboutSliderSection";
import OurSchoolsBlock from "../../components/Content/our_schools";

const Home = () => {
  return (
    <Query query={HOME_QUERY} id={null}>
      {({ data: { home } }) => {
        return (
          <>
            <HomeHeader data={home.data.attributes.headerblock} />
            <IntensivekursBlockNEW />
            <ReferalBlock
              title={home.data.attributes.referal.title}
              desc={home.data.attributes.referal.descr}
              img={home.data.attributes.referal.image.data.attributes}
            />
            <LeistungenBlock />
            <AboutSliderSection />
            <TeamBlock />
            <OurSchoolsBlock className="layout" />
            <FAQBlock />
            <Push />
          </>
        );
      }}
    </Query>
  );
};

export default Home;
